function applyRelativeTimestamp(timeStamp) {
    if (!timeStamp) {
        return "";
    }

    const publishTime = new Date(timeStamp);
    const now = new Date();
    const minutesPassed = (now.getTime() - publishTime.getTime()) / 1000 / 60;
    const hoursPassed = Math.round(minutesPassed / 60);

    if (minutesPassed < 0 || hoursPassed > 24) {
        return "";
    } else if (minutesPassed >= 0 && minutesPassed < 1) {
        return "< 1 min";
    } else if (minutesPassed >= 1 && minutesPassed < 60) {
        return `${Math.round(minutesPassed)} minutes ago`;
    } else if (minutesPassed >= 60 && hoursPassed < 24) {
        return `${hoursPassed} hours ago`;
    }
}

const exported = {
    applyRelativeTimestamp,
};

export default exported;
export { applyRelativeTimestamp };
